import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { BsFillTelephoneXFill, BsFillTelephoneFill } from 'react-icons/bs'
import { useLocation, useNavigate } from 'react-router-dom'
import { acceptCall, declineCall } from '../../socket/services/incomingCall'
import incomingCallRingtone from '../../assets/incoming-call.mp3'
import { getAvatar } from '../../utils/avatar'
import routes from '../../routes/routes'
import constants from '../../utils/constants'
import { isNullOrEmpty, isRecordId, hasAsterisk } from '../../utils/utils'

const NUMBER_NOT_FOUND = 'Número não identificado'

export function IncomingCallPage() {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [displayName] = useState(state)
  const [number, setNumber] = useState(displayName)
  const [recordId, setRecord] = useState('')
  const [ringtone] = useState(new Audio(incomingCallRingtone))

  useEffect(() => {
    const phoneNumber = !isNullOrEmpty(displayName) ? displayName : setNumber(NUMBER_NOT_FOUND)

    if (hasAsterisk(phoneNumber)) {
      !isNullOrEmpty(phoneNumber.split('*')[0]) ? setNumber(phoneNumber.split('*')[0]) : setNumber(NUMBER_NOT_FOUND);
      isRecordId(phoneNumber.split('*')[1]) ? setRecord(phoneNumber.split('*')[1]) : setRecord('');
    }
  }, [displayName])

  const url = `${constants.SALESFORCE_URL}${recordId}`

  const handleCallCancel = () => {
    ringtone.pause()

    declineCall()

    navigate(routes.ContactList.path, { replace: true })
  }

  const handleCallAccept = () => {
    ringtone.pause()

    acceptCall()

    navigate(routes.OngoingCallPage.path, { replace: true, state: { number, timer: 0 } })
  }

  useEffect(() => {
    window.addEventListener('callEnded', () => {
      ringtone.pause()
      navigate(routes.ContactList.path, { replace: true })
    })

    playRingtone()
  }, [])

  const playRingtone = () => {
    ringtone.loop = true
    ringtone.muted = true //chrome 66 update makes us need to start muted audio otherwise an exception will happen
    ringtone.play()
    ringtone.muted = false
  }

  return (
    <main className={styles.mainWrapper}>
      <div className={styles.information}>
        <p>Recebendo ligação</p>
        <div className={styles.avatar}>
          <img
            src={getAvatar(number)}
            className={styles.avatarImage + ' ' + styles.ping}></img>
        </div>
        <div className={styles.userInfo}>
          <p className={styles.number}>{number}</p>
          {isRecordId(recordId) ? 
            <p className={styles.number}><a href={url} target='_blank' rel="noopener noreferrer">Abrir Registro</a></p>
          : null}
        </div>
      </div>
      <hr />
      <div className={styles.buttons}>
        <div
          className={styles.dialNumber + ' ' + styles.rejectCall}
          onClick={handleCallCancel}>
          <div className={styles.number}>
            <BsFillTelephoneXFill />
          </div>
        </div>
        <div
          className={styles.dialNumber + ' ' + styles.acceptCall}
          onClick={handleCallAccept}>
          <div className={styles.number}>
            <BsFillTelephoneFill />
          </div>
        </div>
      </div>
    </main>
  )
}
